import React from 'react';
import { Text, i18n, localizationMaps, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * React functional component representing the drugs details for the mod flex selection.
 * @returns {React.Component} The rendered drugs details component.
 */
const DrugsDetails = ({ data }) => (
    <div style={{ whiteSpace: 'pre-line' }}>
        {
            data.isGraded ?
                <Text small margin="5px 0px 0px 0px">
                    { 
                        i18n.t(
                            tokens.labels.signup.gradedPercentageString, 
                            { firstPercentage: data.firstPercentage, firstMax: data.firstMax, secondPercentage: data.secondPercentage, secondMax: data.secondMax }
                        ) 
                    }
                </Text>
                :
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.reimbursementOf, { reimbursement: data.reimbursement }) }
                </Text>
        }

        {
            data.hasOverallMax &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.overallMaximum, { overallMax: helpers.formatNumber(data.overallMax) }) }</Text>
        }

        <Text small margin="5px 0px 0px 0px">
            { i18n.t(tokens.labels.coverage.genericSubstitute, { genericSubstitute: localizationMaps.fromEnglish("genericSubstitute", data.genericSubstitute) }) }
        </Text>

        {
            data.isPreferredProvider &&
            <React.Fragment>
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.preferredProvider, { preferredProvider: data.preferredProvider }) }
                </Text>
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.preferredProviderReimbursement, { preferredProviderReimbursement: data.preferredProviderReimbursement }) }
                </Text>
            </React.Fragment>
        }

        {
            (data.hasDeductible && data.deductibleAmountSelected) &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.deductibleForSoloCoverage, { soloDeductibleAmount: data.soloDeductibleAmount }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.deductibleForDuoCoverage, { duoDeductibleAmount: data.duoDeductibleAmount })}
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.coverage.deductibleForFamilyCoverage, { familyDeductibleAmount: data.familyDeductibleAmount }) }
                    </Text>
                </React.Fragment>
        }

        {
            (data.hasDeductible && data.deductibleEqualToDispenseFee) &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.deductibleEqualToDispenseFee) }</Text>
        }

        {
            data.hasDispenseFeeMax &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.dispenseFeeMaximum, { dispenseFeeMax: helpers.formatNumber(data.dispenseFeeMax) }) }</Text>
        }

        {
            data.includeErectDysfuncDrugs &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.erectileDysfunctionMaximum, { edMax: helpers.formatNumber(data.edMax) }) }</Text>
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.erectileDysfunctionReimbursement, { edReimbursement: data.edReimbursement }) }</Text>
                </React.Fragment>
        }

        {
            data.includeFertilityDrugs &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.fertilityDrugsMaximum, { fertilityMax: helpers.formatNumber(data.fertilityMax) })}</Text>
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.fertilityDrugsReimbursement, { fertilityReimbursement: data.fertilityReimbursement }) }</Text>
                </React.Fragment>
        }

        {
            data.includePreventativeVaccines ?
                <>
                    {
                        data.preventativeVaccinesIsRC ?
                            <>
                                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.rcExpensesforPreventativeVaccines) }</Text>
                                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.preventativeVaccinesReimbursement, { preventativeVaccinesReimbursement: data.preventativeVaccinesReimbursement })}</Text>
                            </>
                            :
                            <>
                                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.preventativeVaccinesMaximum, { preventativeVaccinesMax: helpers.formatNumber(data.preventativeVaccinesMax) }) }</Text>
                                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.preventativeVaccinesReimbursement, { preventativeVaccinesReimbursement: data.preventativeVaccinesReimbursement }) }</Text>
                            </>
                    }
                </>
                : null
        }

        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.monthWaitingPeriod, { eligibilityPeriod: data.eligibilityPeriod }) }</Text>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.minimumHoursPerWeekRequired, { minHoursPerWeek: data.minHoursPerWeek }) }</Text>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: data.terminationAge }) }</Text>
    </div>
);

export default DrugsDetails;